import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { donorPaths } from '../queries/paths';

// TSS vite/03 — reparto mensual congelado del socio (D-009). Endpoint REAL:
// GET public/liquidations — scoped por liquidation_shares.owner_client_id del
// TOKEN; solo batches generated|posted (el reparto ya está congelado, 0055).
// Sobre público view:"liquidations" → el caller lee envelopeData().items y
// gatea por envelopeModules().includes('economic') (módulo gated donor_owner).
//
// El front NO recalcula: share_amount/percent_snapshot vienen congelados del
// backend (día-tarifa × días × % del snapshot) — solo se formatea.
//
// items[]: { animal:{id,name,number,register},
//            last_liquidation:{ period_year, period_month, days,
//              day_rate_snapshot, pension_amount,
//              my_share:{ percent_snapshot, share_amount } },
//            history:[ { period:"YYYY-MM", pension_amount, my_share } ] } (ASC)

// Keys locales (tuplas TSS 03; recurso propio, sin colisión con donorKeys).
const liquidationKeys = {
    all:    ['liquidations'],
    list:   () => ['liquidations', 'list'],
    animal: (animalId) => ['liquidations', animalId],
};

// Grilla «Mis vacas»: todas las donadoras del socio con reparto (una página
// grande — el tope del endpoint es 100 y un socio tiene pocas decenas de vacas).
export function useClientLiquidations() {
    return useQuery({
        queryKey: liquidationKeys.list(),
        queryFn: ({ signal }) =>
            api.get(donorPaths.liquidations(), { params: { limit: 100 }, signal }).then((r) => r.data),
    });
}

// Detalle de UNA donadora: ?animal_id (gate de co-propiedad server-side —
// ajena/inexistente → 404 anti-enum; items trae 0 o 1 vaca).
export function useClientLiquidation(animalId) {
    return useQuery({
        queryKey: liquidationKeys.animal(animalId),
        queryFn: ({ signal }) =>
            api.get(donorPaths.liquidations(), { params: { animal_id: animalId }, signal }).then((r) => r.data),
        enabled: animalId != null,
    });
}
